import axios from '@axios'

export const APP_STORE_MODULE_NAME = 'apps-city';
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAllData(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/cities/getall`, { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchData(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/cities/getbyid?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addNewData(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/cities/add', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateData(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/cities/update', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        suspend(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/cities/suspend?id=${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
